import React, { useState } from "react";

import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import ButtonCard from "shared/components/ButtonCard";
import NextPreviousFooter from "shared/components/NextPreviousFooter";
import Space from "shared/components/Space";
import Folder from "shared/components/SVG/Folder";
import Invoice from "shared/components/SVG/Invoice";
import Product from "shared/components/SVG/Product";
import { StepStore } from "shared/components/Tab";
import { NAME_SPACES } from "shared/locals/constants";
import { useInfo } from "utils/hooks/info";

import FoldersTitle from "../Common/FoldersTitle";
import { INVOICE, PRODUCTS, FOLDER } from "../constants";
import "./styles.scss";

const Transition = ({ step: { changeTab }, setActiveStep }) => {
  const {
    commonInfo: { contractMandatory },
  } = useInfo();

  const [reference, setReference] = useState();
  const { t } = useTranslation(NAME_SPACES.NEW_FOLDER, {
    keyPrefix: "TRANSITION",
  });

  return (
    <>
      <div className={"newfolder--wrapper--content"}>
        <FoldersTitle title={t("TITLE")} subTitle={t("SUB_TITLE")} />
        <div className={"buttons-card-container"}>
          <ButtonCard
            title={t("BY_INVOICE")}
            icon={<Invoice />}
            onClick={() => setReference(INVOICE)}
            active={INVOICE === reference}
          />
          {!contractMandatory && (
            <ButtonCard
              title={t("BY_FOLDER")}
              icon={<Folder />}
              onClick={() => setReference(FOLDER)}
              active={FOLDER === reference}
            />
          )}
          <ButtonCard
            title={t("BY_PRODUCT")}
            icon={<Product />}
            onClick={() => setReference(PRODUCTS)}
            active={PRODUCTS === reference}
          />
        </div>

        <Space h={32} />
      </div>
      <NextPreviousFooter
        hidePrevious={true}
        onNextClick={() => {
          setActiveStep(1);
          changeTab(reference);
        }}
        nextEnabled={!!reference}
      />
    </>
  );
};

Transition.propTypes = {
  step: PropTypes.shape({
    changeTab: PropTypes.func.isRequired,
  }).isRequired,
  setActiveStep: PropTypes.func.isRequired,
};

Transition.defaultProps = {};

export default StepStore(Transition);
